import React, {createRef} from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import './style.scss';
import {ITimelineItem} from './contract';
import {observer} from 'mobx-react';
import {TimelineItem} from './TimelineItem';

export interface ITimeline {
    data: ITimelineItem[];
    onItemClick: (index: number) => void;
    showLabelIcons?: boolean;
    selectedIndex?: number;
}

@observer
class Timeline extends TechseeBaseComponent<ITimeline> {
    private containerRef = createRef<HTMLDivElement>();

    componentDidUpdate(prevProps: ITimeline): void {
        const {selectedIndex} = this.props;

        if (selectedIndex !== undefined && selectedIndex !== prevProps.selectedIndex) {
            this.scrollToSelected(selectedIndex);
        }
    }

    private scrollToSelected(index: number): void {
        const container = this.containerRef.current;

        if (!container) {
            return;
        }

        const child = container.querySelectorAll('.timeline-item-container')[index] as HTMLElement;

        if (!child) {
            return;
        }

        const containerRect = container.getBoundingClientRect();
        const childRect = child.getBoundingClientRect();
        const isVisible = childRect.left >= containerRect.left && childRect.right <= containerRect.right;

        if (!isVisible) {
            child.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'});
        }
    }

    renderInternal(): JSX.Element {
        const {data, onItemClick, showLabelIcons = false, selectedIndex} = this.props;

        return (
            <div className={'timeline-container'} ref={this.containerRef}>
                {data.map((item, index) => {
                    const isSelected = selectedIndex !== undefined ? index === selectedIndex : item.isSelected;
                    const itemWithSelection = {...item, isSelected};

                    return (
                        <TimelineItem
                            key={index}
                            item={itemWithSelection}
                            index={index}
                            onItemClick={onItemClick}
                            showLabelIcons={showLabelIcons}
                            showLine={index + 1 !== data.length}
                        />
                    );
                })}
            </div>
        );
    }
}

export default Timeline;
